import React from 'react';

interface BlockchainLoaderProps {
  message?: string;
}

const BlockchainLoader: React.FC<BlockchainLoaderProps> = ({
  message = 'Processing blockchain transaction...'
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-md w-full mx-4">
        <div className="flex flex-col items-center">
          {/* Spinner */}
          <div className="relative w-16 h-16 mb-4">
            <div className="absolute inset-0 border-4 border-[#FF3333]/20 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-transparent border-t-[#FF3333] rounded-full animate-spin"></div>
          </div>

          {/* Message */}
          <h3 className="text-lg font-semibold text-[#471b00] font-poly mb-2">
            Processing Transaction
          </h3>
          <p className="text-sm text-[#471b007f] font-dm text-center">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlockchainLoader;
